/**
 * Created by jpilz on 2/13/17.
 */

export default class profileObj {

    constructor() {
        this.name = "ssoObj";

        //Memberbase
        this.BLRUser = "";
        this.BLRUserId = "";

        //WebAuth
        this.WebAuthToken = "";

    }
 

}




// WEBPACK FOOTER //
// ./src/objects/ssoObj.js